export default __webpack_public_path__ + "static/media/possibility_3.0bc656b1.png";